<ng-template #loading>
    <div class="m-loader m-loader--brand pb-5 text-center"></div>
</ng-template>
<div class="m-content">
    <form *ngIf="form; else loading" [formGroup]="form" novalidate ngxsForm="treatmentstate.treatmentform" ngxsFormDebounce="500">
        <div>
            <ng-template #rt let-r="result" let-t="term">
                <strong>{{ r.name }} {{ r.surname }}</strong>
                - {{ r.address }} {{ r.post }} {{ r.city }}
            </ng-template>
            <div class="pb-2">
                <div class="row m-row--no-padding">
                    <div class="m-list-search">
                        <div class="m-list-search__results">
                            <div class="row m-row--no-padding">
                                <div class="col-12">
                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i ngbTooltip="Kratek naslov zdravljenja" class="la la-i-cursor m--font-inverse-light"></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            <input
                                                type="text"
                                                autofocus
                                                placeholder="Kratek naslov zdravljenja"
                                                formControlName="description"
                                                tabindex="1"
                                                class="form-control m-input"
                                            />
                                        </span>
                                    </div>
                                    <div *ngIf="(form?.controls)['description'].errors && isSubmited" class="m--font-danger pl-5">
                                        <small [hidden]="!(form?.controls)['description'].errors.required">
                                            Naslov zdravljenja je obvezno polje.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i
                                                ngbTooltip="Stranka"
                                                class="la la-user m--font-inverse-light"
                                                i18n-ngbTooltip="@@051277a742713d2a4070538ca9ab4f1219346032"
                                            ></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            <input
                                                [ngbTypeahead]="searchForCustomer"
                                                [resultTemplate]="rt"
                                                [inputFormatter]="formatter"
                                                (ngModelChange)="onCustomerChange($event)"
                                                type="text"
                                                placeholder="Poišči stranko"
                                                formControlName="customer"
                                                tabindex="2"
                                                class="form-control m-input"
                                                i18n-placeholder="@@cd522ee85381719f2440edc92ee3ddca50111ae4"
                                            />
                                        </span>
                                        <span *ngIf="searching" class="loading-icon m-input-icon__icon m-input-icon__icon--right">
                                            <span>
                                                <div style="width: 30px; display: inline-block" class="m-loader m-loader--brand"></div>
                                            </span>
                                        </span>
                                    </div>
                                    <div *ngIf="(form?.controls)['customer'].errors && isSubmited" class="m--font-danger pl-5">
                                        <small
                                            [hidden]="!(form?.controls)['customer'].errors.required"
                                            i18n="@@3f2a4ae8d38c57c82e30e93edfa5ac5e6f1269c0"
                                        >
                                            Stranka je obvezno polje.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="form?.value.customer?.id" class="mf-data-group d-flex align-items-stretch">
                                <div>
                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i [tphCallNumber]="form?.value.customer?.phone" class="la la-phone m--font-inverse-light"></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            {{ form?.value.customer?.phone }}
                                        </span>
                                    </div>
                                    <div class="m-list-search__result-item m-input-icon">
                                        <span class="m-list-search__result-item-icon">
                                            <i class="la la-at m--font-inverse-light"></i>
                                        </span>
                                        <span class="m-list-search__result-item-text">
                                            {{ form?.value.customer?.email }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="form?.value.customer?.id && (form?.value.customer.sendSms || form?.value.customer.sendMail)">
                                <div class="m-list-search__result-item m-input-icon">
                                    <span class="m-list-search__result-item-icon">
                                        <i
                                            ngbTooltip="Način obveščanja"
                                            class="la la-bullhorn m--font-inverse-light"
                                            i18n-ngbTooltip="@@6572efc93c050583cc46130c34b451f7d69a6794"
                                        ></i>
                                    </span>
                                    <span class="m-list-search__result-item-text">
                                        <div class="row m-row--no-padding">
                                            <div class="col-xl-6 col-lg-12 col-md-12">
                                                <label *ngIf="form?.value.customer.sendSms" class="m-checkbox m-checkbox--state-brand text-truncate">
                                                    <input
                                                        [checked]="form?.value.customer.sendSms"
                                                        type="checkbox"
                                                        formControlName="smsNotify"
                                                        tabindex="3"
                                                    />
                                                    SMS
                                                    <span></span>
                                                </label>
                                            </div>

                                            <div class="col-xl-6 col-lg-12 col-md-12">
                                                <label
                                                    *ngIf="form?.value?.customer?.sendMail"
                                                    class="m-checkbox m-checkbox--state-brand text-truncate"
                                                >
                                                    <input
                                                        [checked]="form?.value?.customer?.sendMail"
                                                        type="checkbox"
                                                        formControlName="smsNotify"
                                                        tabindex="4"
                                                    />
                                                    EMAIL
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
